import { render } from "./GoyaDominance.vue?vue&type=template&id=7f40117e"
import script from "./GoyaDominance.vue?vue&type=script&lang=js"
export * from "./GoyaDominance.vue?vue&type=script&lang=js"

import "./GoyaDominance.vue?vue&type=style&index=0&id=7f40117e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__